import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  constructor(private httpClient: HttpClient) {}
  private readonly HOST_URL = environment.url_host;

  resetPasswordSession(userName: string): Promise<any> {
    const LOGIN_URL = `${this.HOST_URL}/reset_password_session`;
    const body = new HttpParams().set('email_address', userName.trim());

    let bearerToken = btoa(
      'glimpse_user_name' + ':' + 'glimpse_main_password_123',
    );
    const header = new HttpHeaders().set(
      'Authorization',
      `Basic ${bearerToken}`,
    );
    // .set('Access-Control-Allow-Origin','*')
    // .set('Access-Control-Allow-Methods','POST')

    // header.set('Authorization',`Basic ${bearerToken}`);
    header.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.httpClient
      .post(LOGIN_URL, body, { headers: header })
      .toPromise();
  }

  VerifyOTP(userName: string, otp: string): Promise<any> {
    const LOGIN_URL = `${this.HOST_URL}/verify_otp`;
    const body = new HttpParams()
      .set('email_address', userName.trim())
      .set('otp', otp);

    let bearerToken = btoa(
      'glimpse_user_name' + ':' + 'glimpse_main_password_123',
    );
    const header = new HttpHeaders().set(
      'Authorization',
      `Basic ${bearerToken}`,
    );
    // .set('Access-Control-Allow-Origin','*')
    // .set('Access-Control-Allow-Methods','POST')

    // header.set('Authorization',`Basic ${bearerToken}`);
    header.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.httpClient
      .post(LOGIN_URL, body, { headers: header })
      .toPromise();
  }

  resetOwnersPassword(
    userName: string,
    new_password: string,
    token: string,
  ): Promise<any> {
    const LOGIN_URL = `${this.HOST_URL}/reset_owners_password`;
    const body = new HttpParams()
      .set('email_address', userName.trim())
      .set('new_password', new_password)
      .set('token', token);

    let bearerToken = btoa(
      'glimpse_user_name' + ':' + 'glimpse_main_password_123',
    );
    const header = new HttpHeaders().set(
      'Authorization',
      `Basic ${bearerToken}`,
    );
    // .set('Access-Control-Allow-Origin','*')
    // .set('Access-Control-Allow-Methods','POST')

    // header.set('Authorization',`Basic ${bearerToken}`);
    header.set('Content-Type', 'application/x-www-form-urlencoded');

    return this.httpClient
      .post(LOGIN_URL, body, { headers: header })
      .toPromise();
  }
}
